import { useEffect, useRef, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import {
  DateRangePicker,
  RichTable,
  useNotificationsStore
} from '@thermon-platforms/thermon-ui-core';
import ServiceRow from './service-row';
import api, { downloadFile } from 'util/api';


function ServerHealth() {
  const refreshInterval = useRef();
  const [status, setStatus] = useState();
  const [apiVersion, setApiVersion] = useState();
  const [systemConfiguration, setSystemConfiguration] = useState();
  const [feed, setFeed] = useState([]);
  const [, notificationsStoreActions] = useNotificationsStore();
  const [dateRange, setDateRange] = useState();

  async function queryStatus() {
    const res = await api('/diagnostic');
    const feed = await api('/diagnostic/feed');
    const data = await res.json();
    const feedData = await feed.json();
    setStatus(data);
    setFeed(feedData);
  }

  useEffect(() => {
    queryStatus();
    refreshInterval.current = setInterval(queryStatus, 60 * 1000);

    api('/diagnostic/version').then(res => res.json())
      .then(data => {
        setApiVersion(data);
      })
      .catch(() => {/* no-op */});

    api('/diagnostic/currentConfiguration').then(res => res.json())
      .then(data => {
        setSystemConfiguration(data);
      })
      .catch(() => {/* no-op */});

    return () => {
      if (refreshInterval.current) clearInterval(refreshInterval.current);
    }
  }, []);

  function download() {
    downloadFile(`/diagnostic/logs?startDate=${dateRange.start}&endDate=${dateRange.end}`, `network-health-logs-${dateRange.start}-${dateRange.end}.zip`)
      .catch(res => {
        if (res.status == 404) {
          notificationsStoreActions.notify(
            t`No logs found for selected timeframe.`
          );
        } else {
          notificationsStoreActions.notify(
            t`An error occurred downloading alarm data.`,
            'alert'
          );
        }
      });
  }

  const columns = [
    {
      name: t`Name`,
      key: 'displayName',
      sortable: true
    },
    {
      name: t`State`,
      key: 'serviceState',
      sortable: true
    },
    {
      name: t`Physical Memory Usage (Peak)`,
      key: 'physicalMemoryUsage',
    },
    {
      name: t`Paged Memory Size (Peak)`,
      key: 'pagedMemorySize',
    },
    {
      name: t`Paged System Memory Size (Peak)`,
      key: 'pagedSystemMemorySize',
    },
    // {
    //   name: t`Actions`
    // }
  ];

  const feedColumns = [
    {
      name: t`Alert Type`,
      key: 'systemAlertType',
      sortable: true
    },
    {
      name: t`Alert Status`,
      key: 'systemAlertState',
      sortable: true
    },
    {
      name: t`Associated Item`,
      key: 'associatedItem',
      sortable: true
    },
    {
      name: t`Description`,
      key: 'description',
      sortable: true
    },
    {
      name: t`Recommendation`,
      key: 'recommendation',
      sortable: true
    },
    {
      name: t`Occurred At`,
      key: 'occurredAt',
      sortable: true
    },
  ]

  return (
    <div>
      <section>
        <div className="container-wrapper">
          <RichTable
            columns={columns}
            rows={status}
            responsive={true}
            items={t`services`}
          >
            <ServiceRow />
          </RichTable>
        </div>
        <div className="container-wrapper">
          <RichTable
            className="feed-table"
            columns={feedColumns}
            rows={feed}
            responsive={true}
            items={t`alarms`}
          ></RichTable>
        </div>
        <div className="container-wrapper">
          <h3><Trans>Download Network Health Logs</Trans></h3>
          <DateRangePicker onChange={setDateRange} />
          <button
            className="download"
            onClick={download}
            disabled={!dateRange?.start || !dateRange?.end}
          >
            <Trans>Download</Trans>
          </button>
        </div>
        {systemConfiguration ? <div className="container-wrapper">
          <h3><Trans>System Configuration</Trans></h3>
          <ul>
            <li>
              <strong>MQTT</strong>: {systemConfiguration.mqtt}
            </li>
            <li>
              <strong><Trans>Database Instance</Trans></strong>: {systemConfiguration.genesisDatabase}
            </li>
            <li>
              <strong><Trans>Database Server</Trans></strong>: {systemConfiguration.genesisServer}
            </li>
            <li>
              <strong><Trans>Server</Trans></strong>: {systemConfiguration.server}
            </li>
          </ul>
        </div> : null}
        <div className="container-wrapper">
          <h3><Trans>Versions</Trans></h3>
          <ul>
            {/* NOTE - uiVersion is injected into the global scope in vite.config.js */}
            <li><strong><Trans>UI</Trans></strong>: {uiVersion}</li>
            <li><strong><Trans>API</Trans></strong>: {apiVersion}</li>
          </ul>
        </div>
      </section>
    </div>
  );
}

export default ServerHealth;
